import { B64File } from 'common/classes/B64File.class';
import { Membre } from 'membre/classes/Membre.class';
import { MessagerieService } from 'messagerie/store/service';
import { v4 } from 'uuid';
import { Alerte } from 'common/classes/Alerte.class';
import { Message } from './Message.class';
/**
 * Groupe de membres dans la messagerie
 */
export class Groupe {
    /**
     * Constructeur du Groupe
     * @param row Données du groupe
     */
    constructor(row = {}) {
        var _a, _b, _c;
        const { idGroupe, nom, image, messages, messagesNonLu, membres, membresTotal, dernierMessageLu, totalMessage, alerte, dateCreation, } = row;
        this.uid = idGroupe ? v4() : null;
        this.idGroupe = (_a = Number(idGroupe)) !== null && _a !== void 0 ? _a : null;
        this.nom = nom !== null && nom !== void 0 ? nom : '';
        this.messagesNonLu = messagesNonLu !== null && messagesNonLu !== void 0 ? messagesNonLu : 0;
        this.image = image && new B64File(image);
        this.messages = (_b = messages === null || messages === void 0 ? void 0 : messages.map((message) => new Message(message))) !== null && _b !== void 0 ? _b : [];
        this.membres = (_c = membres === null || membres === void 0 ? void 0 : membres.map((membre) => new Membre(membre.infoPublic))) !== null && _c !== void 0 ? _c : [];
        this.membresTotal = membresTotal !== null && membresTotal !== void 0 ? membresTotal : 0;
        this.dernierMessageLu = dernierMessageLu !== null && dernierMessageLu !== void 0 ? dernierMessageLu : null;
        this.totalMessage = totalMessage !== null && totalMessage !== void 0 ? totalMessage : 0;
        this.alerte = alerte ? new Alerte(alerte) : null;
        this.dateCreation = dateCreation !== null && dateCreation !== void 0 ? dateCreation : null;
    }
    /**
     * Méthode de renvoi de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        var _a, _b;
        return {
            idGroupe: this.idGroupe,
            image: (_b = (_a = this.image) === null || _a === void 0 ? void 0 : _a.toRaw()) !== null && _b !== void 0 ? _b : null,
            nom: this.nom,
            membres: this.membres.map((membre) => membre.toRaw()),
            dateCreation: this.dateCreation,
        };
    }
    /**
     * Enregistre un nouveau groupe
     * @return Identifiant du groupe créé
     */
    save() {
        return MessagerieService.createGroup(this);
    }
    /**
     * Récupère le dernier message de la conversation
     * @return Le dernier message de la conversation
     */
    getLastMessage() {
        var _a;
        return (_a = this.messages) === null || _a === void 0 ? void 0 : _a.at(-1);
    }
    /**
     * Vérifie que le membre passé en paramètre fait parti du groupe
     * @param membre Membre à vérifier
     * @return True si le membre fait parti du groupe
     */
    isInGroup(membre) {
        return this.membres.some((membreGroupe) => membreGroupe.infoPublic.idMembre === (membre === null || membre === void 0 ? void 0 : membre.infoPublic.idMembre));
    }
    /**
     * Fait quitté du groupe l'utilisateur connecté
     * @return True si l'opération a réussie
     */
    leave() {
        return MessagerieService.leaveGroup(this.idGroupe);
    }
    /**
     * Définit une conversation comme lue
     * @return Nombre de messages lus grâce à l'action
     */
    setConversationRead() {
        this.messagesNonLu = 0;
        return MessagerieService.setConversationRead(this.idGroupe, true);
    }
    /**
     * Supprime la conversation pour le membre connecté
     */
    deleteConversation() {
        return MessagerieService.deleteConv(this.idGroupe, true);
    }
}
//# sourceMappingURL=data:application/json;base64,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